import { ScatterplotLayer, BitmapLayer} from 'deck.gl';

import { scaleLinear } from "d3-scale"

const heightScale = scaleLinear()
  .domain([0,1,2,3,4,5,6,7])
  .range([10000,5000,2500,1000,500, 100, 10])


export function renderLayers({data}) {
 

  const img = new BitmapLayer({
    id: 'bitmap-layer',
    bounds: [512*5, 512*5, 0, 0],
    image: 'img/tile4-min.png'
  });

  //レイヤーの重なり順を配列で指定(先頭のレイヤーが一番下になる)
  return [img];
}
